import '../assets/css/searchBar.css';
import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import Loader from '../assets/img/loader.svg';
export const SearchBarProspect = (props) => {
   


    return (
        <div id="searchBarEdit" className={props.fixedElement}>
            <form onSubmit={(event) => {
                event.preventDefault()
            }}>
                <input placeholder="Entreprise ou info du contact"
               
                type="search" onChange={(e) => { props.setFilterSearch(e.target.value.toLowerCase()) }} />
                <button type="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.238" height="30.239" viewBox="0 0 30.238 30.239"><g transform="translate(-0.001 0)"><path d="M20.194,3.46a11.833,11.833,0,1,0-1.618,18.075,2.491,2.491,0,0,0,.676,1.254l6.718,6.718a2.5,2.5,0,0,0,3.535-3.535l-6.718-6.72a2.5,2.5,0,0,0-1.253-.674A11.845,11.845,0,0,0,20.194,3.46ZM18.073,18.074a8.833,8.833,0,1,1,0-12.492A8.843,8.843,0,0,1,18.073,18.074Z" /></g></svg>
                </button>
                <span></span>
            </form>

           

















        </div>
    )
}